export default __webpack_public_path__ + "static/media/facebook.11258f44.svg";